import {SwiperComponent} from "./Swiper";
import {toPixels} from "../util/units";
import {createLogger} from "../util/logger";

const console = createLogger("SwiperMietflaechen");

export class TextSwiper extends SwiperComponent {
    static name = "text-swiper";

    /**
     *
     * @return {SwiperOptions}
     */
    get options() {
        return Object.assign({}, super.options, {
            spaceBetween: 32,
            slidesPerView: "auto",
            on: {
                slideChange: this.onSlideChange.bind(this),
                slideChangeTransitionStart: this.onSlideChangeTransitionStart.bind(this),
                slideChangeTransitionEnd: this.onSlideChangeTransitionEnd.bind(this),
            }
        });
    }

    constructor(el) {
        super(el);

        /**
         * @type {HTMLElement}
         */
        this.$text = this.el.querySelector(".swiper > .text");

        /**
         * @type {HTMLElement[]}
         */
        this.$slideTexts = Array.from(this.el.querySelectorAll(".swiper-slide .text") || []);

        /**
         * @type {HTMLElement}
         */
        this.$nav = this.el.querySelector(".nav");

        /**
         * @type {HTMLElement[]}
         */
        this.$navButtons = Array.from(this.$nav?.querySelectorAll("button") || []);

        this.addEventListener(this.$navButtons, "click", this.onClickNavButton.bind(this));

        this.update(this.swiper);
    }


    update() {
        this.$navButtons.forEach((btn, i) => {
            if (i !== this.swiper.activeIndex) {
                btn.parentElement.classList.remove("current-menu-item");
            } else {
                btn.parentElement.classList.add("current-menu-item");
            }
        });

        this.updateText(this.swiper);
    }

    updateText(swiper) {
        console.log("updateText", swiper.activeIndex, this.$slideTexts);

        const $text = this.$slideTexts[swiper.activeIndex];

        const textRect = $text.getBoundingClientRect();

        this.$text.style.setProperty("--width", toPixels(textRect.width));
        this.$text.style.setProperty("--height", toPixels(textRect.height));

        this.$text.classList.add("--transitioning");

        setTimeout(() => {
            this.$text.firstElementChild.innerHTML = $text.innerHTML;
            this.$text.classList.remove("--transitioning");
        }, 400);


    }

    /**
     * @param {MouseEvent} e
     */
    onClickNavButton(e) {
        console.log("onClickNavButton");
        const i = this.$navButtons.indexOf(e.currentTarget);

        this.swiper.slideTo(i);
    }

    onSlideChange(swiper) {
        this.update();
    }

    onSlideChangeTransitionStart(swiper) {
    }

    onSlideChangeTransitionEnd(swiper) {
    }

    getNextIndex(swiper) {
        if (swiper.swipeDirection === "next") {
            return swiper.activeIndex + 1;
        }
        return swiper.activeIndex - 1;
    }


}
